(function () {
  // 100ms x 150 = 15s. If usf never fully initializes in that window,
  // the whole filtering feature is broken anyway (not just this button) -
  // show it regardless rather than polling forever and leaving it
  // permanently hidden, which is what happened before this had a timeout.
  var USF_READY_TIMEOUT_MS = 15000;
  var USF_READY_POLL_MS = 100;

  function isUsfReady() {
    return !!(window.usf && window.usf.event && window.usf.store && window.usf.utils);
  }

  function whenUsfReady(callback) {
    if (isUsfReady()) {
      callback();
      return;
    }
    var elapsed = 0;
    var interval = setInterval(function () {
      elapsed += USF_READY_POLL_MS;
      if (isUsfReady()) {
        clearInterval(interval);
        callback();
      } else if (elapsed >= USF_READY_TIMEOUT_MS) {
        clearInterval(interval);
        callback();
      }
    }, USF_READY_POLL_MS);
  }

  whenUsfReady(function () {
    var wrap = document.querySelector('[data-sticky-filter-btn]');
    var trigger = document.querySelector('[data-sticky-filter-trigger]');
    var countEl = document.querySelector('[data-sticky-filter-count]');
    if (!wrap || !trigger || !countEl) return;

    // Reveal the button unconditionally, before anything below that could
    // throw (store access, event registration) - this callback only runs
    // once (whenUsfReady's interval is already cleared by the time it
    // fires), so if an exception aborted the function before this point,
    // the button stayed hidden forever with no retry. isUsfReady() only
    // checks that window.usf.store/.event/.utils exist, not that they're
    // fully functional yet, so that store access throwing was a real gap.
    document.body.classList.add('sticky-filter-enabled');
    wrap.hidden = false;

    function updateCount() {
      if (!isUsfReady()) return;
      try {
        var store = window.usf.store.useFacetsStore();
        var count = store && store.facetFilterIds ? store.facetFilterIds.length : 0;
        countEl.textContent = count;
        countEl.hidden = count === 0;
      } catch (e) {
        // Count display is a nice-to-have; the button itself must stay
        // visible either way. Logged since a throw here used to hide the
        // whole button with no other trace of why.
        if (window.console && console.warn) console.warn('sticky-filter-button: count update failed', e);
      }
    }

    // usf.app (read by onMobileToggleFilters) is only set once usf.js's
    // Vue app actually mounts, a step after usf.store/.event/.utils exist -
    // guard the click instead of assuming readiness implies usf.app is
    // there too, so a mistimed click fails quietly instead of throwing.
    trigger.addEventListener('click', function () {
      if (window.usf && window.usf.app && window.usf.utils && window.usf.utils.onMobileToggleFilters) {
        window.usf.utils.onMobileToggleFilters();
      }
    });

    if (isUsfReady()) {
      window.usf.event.add(['init', 'sr_updated', 'sr_viewChanged', 'rerender'], updateCount);
      updateCount();
    }
  });
})();
